export enum CategoryRouteName {
    Index = 'system.categories.index',
    Create = 'system.categories.create',
    Edit = 'system.categories.edit',
}

export default {
    path: 'categories',
    name: CategoryRouteName.Index,
    component: () => import('@/views/system/category/Index.vue'),
    meta: {
        auth: true,
        label: 'Categories',
        icon: 'fal fa-folder-tree fa-fw',
        group: 'main',
        location: 'sidebar',
        permission: 'manage-categories',
    },
    children: [
        {
            path: 'create',
            name: CategoryRouteName.Create,
            component: () => import('@/views/system/category/Index.vue'),
            meta: {
                auth: true,
                label: 'Create Category',
                icon: 'fal fa-folder-tree fa-fw',
                group: 'main',
                location: 'sidebar',
                permission: 'manage-categories',
            },
        },
        {
            path: ':categoryUuid/edit',
            name: CategoryRouteName.Edit,
            component: () => import('@/views/system/category/Index.vue'),
            meta: {
                auth: true,
                label: 'Edit Category',
                icon: 'fal fa-folder-tree fa-fw',
                group: 'main',
                location: 'sidebar',
                permission: 'manage-categories',
            },
        },
    ],
}
